import { ArrowBack } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import useHistoryPenyewa from "../../services/queries/useHistoryPenyewa";

interface IModalHistoryPenyewaProps {
    isOpenModalHistoryPenyewa: boolean;
    closeModalHistoryPenyewa: () => void;
    namaPenyewa: string;
    idPenyewa: string;
}

const ModalHistoryPenyewa = ({
    isOpenModalHistoryPenyewa,
    closeModalHistoryPenyewa,
    namaPenyewa,
    idPenyewa,
}: IModalHistoryPenyewaProps) => {
    const moment = require("moment");

    const { data: historyPenyewa, isLoading: isLoadingHistory } =
        useHistoryPenyewa(parseInt(idPenyewa), isOpenModalHistoryPenyewa);

    const formatCurrency = (amount: number) => {
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(amount);
    };

    const formatDateTime = (dateTime: string) => {
        return moment(dateTime).format("D MMMM YYYY HH:mm");
    };

    const formatDate = (date: string) => {
        return moment(date).format("D MMMM YYYY");
    };

    return (
        <Dialog
            maxWidth="lg"
            fullWidth={true}
            open={isOpenModalHistoryPenyewa}
            onClose={closeModalHistoryPenyewa}
            PaperProps={{
                sx: { borderRadius: 1, minHeight: 400 },
            }}
        >
            <DialogTitle>
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    display="flex"
                    justifyContent="space-between"
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <IconButton
                            onClick={closeModalHistoryPenyewa}
                            size="small"
                        >
                            <ArrowBack />
                        </IconButton>
                        <Typography variant="h6" fontWeight="bold">
                            Riwayat Penyewa - {namaPenyewa}
                        </Typography>
                    </Stack>

                    <IconButton onClick={closeModalHistoryPenyewa}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>

            <DialogContent>
                {isLoadingHistory ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        minHeight={200}
                    >
                        <Typography>
                            Memuat data riwayat penyewaan...
                        </Typography>
                    </Box>
                ) : historyPenyewa?.sewaList &&
                  historyPenyewa.sewaList.length > 0 ? (
                    <TableContainer
                        component={Paper}
                        sx={{
                            maxHeight: 400,
                            boxShadow: "none",
                            // border: '1px solid #e0e0e0'
                        }}
                    >
                        <Table
                            stickyHeader
                            aria-label="riwayat penyewaan table"
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: "bold" }}>
                                        Ruangan
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }}>
                                        Awal Sewa
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }}>
                                        Akhir Sewa
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }}>
                                        Harga
                                    </TableCell>
                                    <TableCell
                                        sx={{ fontWeight: "bold" }}
                                        align="center"
                                    >
                                        Pax
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }}>
                                        Tanggal Transaksi
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {historyPenyewa.sewaList.map((sewa, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{
                                            "&:last-child td, &:last-child th":
                                                { border: 0 },
                                            "&:hover": {
                                                backgroundColor: "#fafafa",
                                            },
                                        }}
                                    >
                                        <TableCell>
                                            <Tooltip title={sewa.namaRuangan}>
                                                <span className="table-cell-trucate">
                                                    {sewa.namaRuangan}
                                                </span>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip
                                                title={formatDateTime(
                                                    sewa.awalSewa,
                                                )}
                                            >
                                                <span className="table-cell-trucate">
                                                    {formatDateTime(
                                                        sewa.awalSewa,
                                                    )}
                                                </span>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip
                                                title={formatDateTime(
                                                    sewa.akhirSewa,
                                                )}
                                            >
                                                <span className="table-cell-trucate">
                                                    {formatDateTime(
                                                        sewa.akhirSewa,
                                                    )}
                                                </span>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip
                                                title={formatCurrency(
                                                    sewa.harga,
                                                )}
                                            >
                                                <span className="table-cell-trucate">
                                                    {formatCurrency(sewa.harga)}
                                                </span>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Tooltip
                                                title={`${sewa.kapasitas} Orang`}
                                            >
                                                <span className="table-cell-trucate">
                                                    {sewa.kapasitas} Orang
                                                </span>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip
                                                title={formatDate(
                                                    sewa.tanggalTransaksi,
                                                )}
                                            >
                                                <span className="table-cell-trucate">
                                                    {formatDate(
                                                        sewa.tanggalTransaksi,
                                                    )}
                                                </span>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        mt={10}
                    >
                        <Typography
                            fontWeight={600}
                            fontSize={25}
                            textAlign="center"
                        >
                            Belum ada Riwayat Penyewaan
                        </Typography>
                    </Box>
                )}
            </DialogContent>

            <DialogActions sx={{ padding: 2 }}>
                <Button
                    variant="contained"
                    onClick={closeModalHistoryPenyewa}
                    color="primary"
                >
                    Kembali
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalHistoryPenyewa;
